// See: https://stackoverflow.com/a/16427747/1515053
function isAvailable() {
  var test = 'local-storage-test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}

const isLocalStorageAvailable = isAvailable();

export { isLocalStorageAvailable };
